import { Children, FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { desktopCSS, mobileAndTabletCSS } from '@measures/responsive'
import useHasInvertedColors from '@hooks/useHasInvertedColors'

export interface SponsoredLabelProps {
  children?: ReactNode
}

export interface InvertedColorsStyledProps {
  hasInvertedColors: boolean
}

export interface StyledSponsoredLabelProps extends InvertedColorsStyledProps {
  hasLogo: boolean
}

const StyledSponsoredLabel = styled.div<StyledSponsoredLabelProps>`
  ${({
    theme: {
      spacing: { spacing8 },
      colors: { textWeak, staticNeutral400 },
      typography: {
        catchword: {
          small1: { bundledCSS: small1CatchwordCSS },
        },
      },
    },
    hasLogo,
    hasInvertedColors,
  }) => {
    const nonDesktopWithLogoCSS = css`
      line-height: 20px;
      > :nth-child(2) {
        vertical-align: top;
        display: inline-block;
      }
    `

    return css`
      ${small1CatchwordCSS};
      color: ${hasInvertedColors ? staticNeutral400 : textWeak};
      text-transform: uppercase;
      margin-bottom: ${spacing8};

      ${desktopCSS(css`
        display: grid;
        grid-template-columns: auto;
        grid-template-rows: auto 1fr;
        grid-row-gap: ${spacing8};
      `)};

      ${hasLogo &&
      css`
        ${mobileAndTabletCSS(nonDesktopWithLogoCSS)};
      `}
    `
  }}
`

const Spacer = styled.div`
  ${({
    theme: {
      spacing: { spacing8 },
    },
  }) => css`
    display: inline-block;
    width: ${spacing8};
    ${desktopCSS(css`
      display: none;
    `)}
  `}
`

const SponsoredLabel: FunctionComponent<SponsoredLabelProps> = ({
  children,
}) => {
  const hasInvertedColors = useHasInvertedColors()

  const childrenAsArray = Children.toArray(children)
  const hasLogo = childrenAsArray.length > 1
  return (
    <StyledSponsoredLabel
      hasLogo={hasLogo}
      hasInvertedColors={hasInvertedColors}>
      {[childrenAsArray[0], <Spacer key="spacer" />, childrenAsArray[1]]}
    </StyledSponsoredLabel>
  )
}

export default SponsoredLabel
